import axios from 'axios';
import '../_configs';
import { store } from '../redux/store';

const config = global.gConfig;

// let mainUrl = `${config.webUrl}/cnsauth/`;
let mainUrl = process.env.REACT_APP_CNSAUTH_URL;
let apiKey = config.apiKey;

const instance = axios.create({
	baseURL: mainUrl,
	headers: { Accept: 'application/json' },
});

// For Add Instance Options In the Future
// axios.defaults.headers.common['Authorization'] = 'AUTH TOKEN';
instance.defaults.headers.post['Content-Type'] = 'application/json';
// instance.defaults.headers.delete['Content-Type'] = 'application/json';
// axios.defaults.headers.common['api key'] = 'x-api-key';
instance.defaults.headers['x-api-key'] = apiKey;
// instance.defaults.headers.post['x-api-key'] = apiKey;

// Interceptors Request
instance.interceptors.request.use(
	(request) => {
		// Edit request config
		// const user = localStorage.getItem('user');
		const state = store.getState();
		const user = state.authentication.user;
		if (user && !request.headers.hasOwnProperty('Authorization')) {
			request.headers['Authorization'] = 'Bearer ' + user.accessToken;
		}
		return request;
	},
	(error) => {
		console.log(error);
		return Promise.reject(error);
	}
);

// Interceptors Response
instance.interceptors.response.use(
	(response) => {
		// Edit response config
		return response.data;
	},
	(error) => {
		console.log(error);

		return Promise.reject(error);
	}
);

export default instance;
